import { render, staticRenderFns } from "./MembershipUpsellModal.vue?vue&type=template&id=484ca5cc&"
import script from "./MembershipUpsellModal.vue?vue&type=script&lang=js&"
export * from "./MembershipUpsellModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MembershipUpsellModal.vue"
export default component.exports